export default "__VITE_ASSET__CqQjPTEY__"